export default {
  getHead: () => {
    return [{ name: '대상 회사명' }, { name: '피평가자' }, { name: '평가일' },  { name: '작성자' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name       // 대상 회사명
      case 1: return func.getContent(value).inputA_5       // 피평가자
      case 2: return func.getContent(value).inputA_6       // 평가일
      case 3: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '대상 회사명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '피평가자': return ['content$body.inputA_5*%[:default_skw]%']
    case '평가일': return ['content$body.inputA_6*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
  },
}
